exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".observer[data-v-97d5170e]{height:1px;margin-bottom:100px}", ""]);

// exports
